import React from 'react'
import { Button, Modal } from 'antd'
import {DangerInfoIcon, ModalCloseIco, ModalErrorIco, ModalSuccessIco} from '../../../modules/CustomIcons'

import './index.scss'
import { useTranslation } from 'react-i18next'

/*interface ModalProps {
  children: React.ReactNode
  visible: boolean,
  title: String,
  width: number,
  height: number,
  // setVisible: (visibility: Boolean) => void
  onOk: () => void,
  className: string,
  onCancel: () => void
}*/
const SuccessOrErrorModal: React.FC<any> = (props : any) => {
    const {t} = useTranslation()
    const isCustomError = !!props.errorIcon && props.modalType !== 'success' && props.modalType !== 'info'
    const modalFooter = () => (
        <>
            <div className='flex justify_end align_center'>
                <Button type="primary" className='modal_ok_btn ' onClick={props?.onClose || props?.onCancel}  >{props.onCloseText || (props.modalType === 'success' ? 'OK' : t("common.close"))}</Button>
            </div>
        </>
    )

  return (
    <>
        {
            props.visible && <Modal
                title={props.modalTitle}
                closeIcon={ props.closeIcon === null ? false :<ModalCloseIco />}
                centered
                visible={props.visible}
                onOk={props?.onOk}
                onCancel={props?.onCancel}
                width={props.width || 580}
                className={`success_or_error_modal manage_faster_menus  no_footer ${props.closeIcon === null?'close_none':''}  ${props?.className}`}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={props.modalFooter || modalFooter()}
            >

                <div className={`flex align_center google_auth_modal_body  ${ props?.delete && 'delete_modal_status_div' } `}>
                    <div className={`${props.delete ? 'modal_icon_div_Delete' : 'modal_icon_div'} ${isCustomError ? 'custom_error_icon' : ''}`}>
                        {
                            props.modalType=='success' ? <ModalSuccessIco /> : props.modalType === 'info' ? <DangerInfoIcon />:(props.errorIcon || <ModalErrorIco />)
                        }
                    </div>
                    <p className={props.delete ? 'modal_icon_div_title_delete' : 'modal_icon_div_title'}>{props.modalText}</p>
                </div>

            </Modal>
        }
    </>
  )
}

export default SuccessOrErrorModal
